/**
 * Host events plugin is used to send plugins from inside the prosemirror instance to the
 * ancestor(s) of the text editor component.
 */
import { ProseMirrorViewController } from "@/wc/text-editor/lib/lit-prosemirror-controller/index.js";
import { EditorState, PluginKey } from "prosemirror-state";
export interface EditorHostInterface {
    dispatchEvent: (name: string, detail?: unknown) => void;
    getController: () => ProseMirrorViewController;
}

export const HOST_EVENT_PLUGIN = new PluginKey<EditorHostInterface>(
    "HOST_EVENT_PLUGIN"
);

/**
 * Dispatch an event from the editor component to the host page.
 * @param editorState Editor state that contains a host event plugin (installed by lit-prosemirror-controller)
 * @param name Name of the event, will be prefixed with name of the editor element
 *   (e.g. c-text-editor:event-name)
 * @param detail Payload for the event
 */

export const dispatchHostEvent = (
    editorState: EditorState,
    name: string,
    detail?: unknown
) => {
    HOST_EVENT_PLUGIN.getState(editorState)?.dispatchEvent(name, detail);
};

/**
 * Get a handle on the ProseMirror controller from the plugin state. Should be used with care,
 * but this is neccessary to do things like dump debug info from a menu action.
 */
export const getController = (
    editorState: EditorState
): ProseMirrorViewController | undefined => {
    return HOST_EVENT_PLUGIN.getState(editorState)?.getController();
};
